module.exports = __webpack_public_path__ + "img/training_room-right.7d3e1e82.jpg";